export default "__VITE_ASSET__CNy4zPSB__"